import { render, staticRenderFns } from "./Factors.vue?vue&type=template&id=17ab37cd&scoped=true"
import script from "./Factors.vue?vue&type=script&lang=ts"
export * from "./Factors.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17ab37cd",
  null
  
)

export default component.exports